var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChapter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-chapter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30005 6.00001C3.30005 5.50295 3.70299 5.10001 4.20005 5.10001L19.8 5.10001C20.2971 5.10001 20.7001 5.50295 20.7001 6.00001C20.7001 6.49706 20.2971 6.90001 19.8 6.90001L4.20005 6.90001C3.70299 6.90001 3.30005 6.49706 3.30005 6.00001ZM3.30005 12C3.30005 11.503 3.70299 11.1 4.20005 11.1L16.2 11.1C16.6971 11.1 17.1 11.503 17.1 12C17.1 12.4971 16.6971 12.9 16.2 12.9L4.20005 12.9C3.70299 12.9 3.30005 12.4971 3.30005 12ZM4.20005 17.1C3.70299 17.1 3.30005 17.503 3.30005 18C3.30005 18.4971 3.70299 18.9 4.20005 18.9L19.8 18.9C20.2971 18.9 20.7001 18.4971 20.7001 18C20.7001 17.5029 20.2971 17.1 19.8 17.1H4.20005Z",
    fill: "#47494D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChapter);
export default __webpack_public_path__ + "static/media/icon-chapter.37047e9bc79948e3bf319338a2e7393e.svg";
export { ForwardRef as ReactComponent };